import { Wallet } from './wallet/wallet';

export {
    Wallet
};



// WEBPACK FOOTER //
// ./src/providers/providers.ts